module.exports = __webpack_public_path__ + "img/curr_play.113e82b4.png";